/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Files_User_SystemInputs */

const es_settings_files_user_system = /** @type {(inputs: Settings_Files_User_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sistema`)
};

const en_settings_files_user_system = /** @type {(inputs: Settings_Files_User_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`system`)
};

/**
* | output |
* | --- |
* | "system" |
*
* @param {Settings_Files_User_SystemInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_files_user_system = /** @type {((inputs?: Settings_Files_User_SystemInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Files_User_SystemInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_files_user_system(inputs)
	return en_settings_files_user_system(inputs)
});
export { settings_files_user_system as "settings.files.user.system" }